<template>
    <div style="width: 620px;margin: 30px auto">
        <div style="margin: 10px auto 30px 50px">
            <a style="font-size: 20px;color:#407338">Transcription factor gene families in <i>B. rapa</i></a>
        </div>
        <el-table
            ref="filterTable"
            :data="TranscriptionFactorGene_list"
            height="580px"
            line-hight="10px"
            border
            header-cell-style="color:#407338;text-align:center"
            :row-style="{height:'35px'}"
            cell-style="color:#407338;text-align:center">
            <el-table-column prop="subfamily" label="Sub family" width="300px"></el-table-column>
            <el-table-column prop="number" label="Gene (B. rapa)" width="300px">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleSubfamilyNum(scope.row)" style="color: #3742fa">{{scope.row.number}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "TranscriptionFactorGene",
        data() {
            return {
                TranscriptionFactorGene_list: {},
                boxtarget: 0,
                Ath_boxtarget: 0,
                selection_gene: '',
            }
        },
        mounted() {
            this.get_TranscriptionFactorGene_list()
        },
        components: {

        },
        methods: {
            get_TranscriptionFactorGene_list() {
                axios({
                    url: 'http://39.100.233.196:8001/api/get-transcriptionfactor-gene/',
                    type: 'json',
                    method: 'get',
                }).then((res) => {
                    this.TranscriptionFactorGene_list = res.data
                    // console.log(this.TranscriptionFactorGene_list)
                })
            },
            handleSubfamilyNum(row) {
                // console.log(row.subfamily)
                this.$router.push({path: '../SearchTranscriptionFactorGene/', query: {subfamily: row.subfamily}})
            },
        }
    }
</script>

<style>

</style>